import { render } from "./LinkProductsToCustomerDiscountGroupModal.html?vue&type=template&id=37f9f0bb&scoped=true"
import script from "./LinkProductsToCustomerDiscountGroupModal.js?vue&type=script&lang=js"
export * from "./LinkProductsToCustomerDiscountGroupModal.js?vue&type=script&lang=js"

import "./LinkProductsToCustomerDiscountGroupModal.css?vue&type=style&index=0&id=37f9f0bb&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f9f0bb"]])

export default __exports__